export type PageItem = number | "gap";

/**
 * Ko'rinadigan sahifa tugmalari: birinchi, oxirgi va joriy atrofidagilar.
 * 7 tadan ko'p tugma qatorni sindirardi: `1 … 4 5 6 … 20`.
 */
export function pageWindow(page: number, total: number): PageItem[] {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  const start = Math.max(2, Math.min(page - 1, total - 4));
  const end = Math.min(total - 1, Math.max(page + 1, 5));
  const items: PageItem[] = [1];
  if (start > 2) items.push("gap");
  for (let i = start; i <= end; i++) items.push(i);
  if (end < total - 1) items.push("gap");
  items.push(total);
  return items;
}
